import axios from "axios";
import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import * as loadingData from "../loadingSetdataTool.json";
import FadeIn from "react-fade-in/lib/FadeIn";
import { FetchAxiosGet } from "../../../../api/axios";
import { GetCookieData, GetCookieToken } from "../../../Cookie/GetCookie";
import LoadingData from "../../../TESTPage/LoadingData";
import ModalUser from "../../../SetData/SetCommander/ModalUser";
import MyThaiDatePick from "../../../../components/Common/ThaiDatePicker";
import { useInsertConText } from "../../../Context/InsertContext";
import ExcelExportComponent from "../../Report/ExcelExportComponent";
import { ConvertDate } from "../../../Function/ConvertDate";

const Menu3 = () => {
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const filterSubAdmin = user?.positionSubAdmin?.map(i => i.type_sub_admin);
  const baseURL = process.env.REACT_APP_API_CORS;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataInfo, setDataInfo] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const user_id = user.user_id;
  const [totalPage, setTotalPage] = useState();

  const getData = () => {
       setLoading(true)
       setTimeout(async () => {
         let  params = new URLSearchParams({
           page: currentPage,
           size: 10,
           "order[0]": "created_date",
           "order[1]": "DESC",
           "filter[status][0]": 0,
           "filter[status][1]": 1,
           "filter[status][2]": 2,
         });
         if (filterSubAdmin.length === 0 || (Number(filterSubAdmin) !== 0 && Number(filterSubAdmin) !== 4)) {
           params.append("filter[users_id_borrow][0]", user_id)
         }
         const borrowData = await FetchAxiosGet("/api/borrow/equipment/datatable",token,params)
         setData(borrowData.result)
         setDataInfo(borrowData.info)
         setTotalPages(Math.ceil(borrowData.info.totalRows / borrowData.info.pageSize));
         setLoading(false)
       }, 1000);
     };

  useEffect(() => {
    const getData = () => {
      setLoading(true)
      setTimeout(async () => {
        let groupArray = []
        let  params = new URLSearchParams({
          page: currentPage,
          size: 10,
          "order[0]": "created_date",
          "order[1]": "DESC",
          "filter[status][0]": 0,
          "filter[status][1]": 1,
          "filter[status][2]": 2,
        });
        if (filterSubAdmin.length === 0 || (Number(filterSubAdmin) !== 0 && Number(filterSubAdmin) !== 4)) {
          params.append("filter[users_id_borrow][0]", user?.user_id)
        }
        const borrowData = await FetchAxiosGet("/api/borrow/equipment/datatable",token,params)
        borrowData.result?.map( i =>{
          groupArray.push(Number(i.equipment_id))
        })
        letEquipmentName(groupArray)
        setData(borrowData.result)
        setDataInfo(borrowData.info)
        setTotalPages(Math.ceil(borrowData.info.totalRows / borrowData.info.pageSize));
        setLoading(false)
      }, 1000);
    };
    getData();
  }, [currentPage]);

  const [allEquipment, setAllEquipment] = useState([])
  const letEquipmentName = async (id) =>{
    let params = new URLSearchParams({
      page: currentPage,
      size: 10,
      "order[0]": "item_id",
      "order[1]": "ASC",
    });
    id.forEach((element,idx) => {
      params.append(`filter[item_id][${idx}]`,element)
    });
    const fetchEquipment = await FetchAxiosGet("/api/equipment/datatable",token,params)
    setAllEquipment(fetchEquipment.result)
  }

  const [searchData, setSearchData] = useState({
    mDataName: null,
    dateBorrow: null,
    dateReturn: null,
    equipmentId: null,
    status: null,
    userNameBorrow: null,
    serialNumber: null,
    opdcId: null
  });

  const [typeData, setTypeData] = useState([])

  const allTypeOptions = [{ type_name: "ทั้งหมด", type_name_count: null }, ...typeData];

  const filterHasData = () => {
    if (
      searchData.mDataName !== null ||
      searchData.dateBorrow !== null ||
      searchData.dateReturn !== null ||
      searchData.equipmentId !== null ||
      searchData.status !== null ||
      searchData.userNameBorrow !== null ||
      searchData.serialNumber !== null ||
      searchData.opdcId !== null
      ) {return true;} else {return false;}
  }

  const getSeachData = async (page) => {

    const pageParam = page || 1;
    
    const url = `${baseURL}/api/borrow/equipment/datatable`;

    let fetchEquipment = null
    let fetchOPDCid = null

    let exList = [
      // {"filter[mdata_name][0]" : searchData.mDataName},
      {"filter[dmy_borrow][0]" : searchData.dateBorrow},
      {"filter[dmy_return][0]" : searchData.dateReturn},
      {"filter[status][0]" : searchData.status},
      {"filter[users_name_borrow][0]": searchData.userNameBorrow === "ทั้งหมด" ? null : searchData.userNameBorrow},
      // {"filter[][0]" : searchData.serialNumber},
      {"filter[item_format][0]" : searchData.opdcId},
    ];

    let params = new URLSearchParams({
      page: pageParam,
      size: 10,
      "order[0]": "created_date",
      "order[1]": "DESC",
      "filter[users_id_borrow][0]": user_id,
    });

    if (searchData.opdcId !== null) {
      let params  = new URLSearchParams({
        page: pageParam,
        size: 10,
        "order[0]": "item_id",
        "order[1]": "ASC",
      });
      params.append("filter[item_format][0]",searchData.opdcId)
      fetchOPDCid = await FetchAxiosGet("/api/equipment/datatable",token,params)
      fetchOPDCid = fetchOPDCid?.result[0]
      exList.push({"filter[equipment_id][0]" : fetchOPDCid?.item_id})
    }

    if (searchData.equipmentId !== null) {
      let params  = new URLSearchParams({
          page: pageParam,
          size: 10,
          "order[0]": "item_id",
          "order[1]": "ASC",
      });
      if (searchData.equipmentId === "ทั้งหมด") {
        params.delete("filter[type_name][0]",searchData.equipmentId)
      } else {
        params.append("filter[type_name][0]",searchData.equipmentId)
        fetchEquipment = await FetchAxiosGet("/api/equipment/datatable",token,params)
        fetchEquipment = fetchEquipment.result
      }
    }

    if (filterSubAdmin.length > 0 && 
      (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4)) {
        params.delete("filter[users_id_borrow][0]");
    }

    if (fetchEquipment !== null) {
      fetchEquipment?.map((element,idx) =>{
        params.append(`filter[equipment_id][${idx}]` , element?.item_id);
      })
    }

    exList.forEach((item) => {
      for (let key in item) {
        if (item[key] !== null && item[key] !== "" && item[key] !== undefined) {
          params.append(key, item[key]);
        }
      }
    });

    let groupArray = []
    

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then((res) => {
        setData(res.data.result);
        res.data.result?.map( i =>{
          groupArray.push(Number(i.equipment_id))
        })
        letEquipmentName(groupArray)
        setCurrentPage(res.data.info.currentPage);
        setTotalPage(res.data.info.totalPage);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getTypeData()
    //typeData.unshift({ type_name: "ทั้งหมด", type_name_count: null })
  }, [])

  const getTypeData = () => {
    
    const url = `${baseURL}/api/equipment/type`;

    axios
      .get(url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setTypeData(res.data.result);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const { insert, setInsert } = useInsertConText();
  useEffect(() => {
    if (insert.task === "select_user_filter") {
      setSearchData((prev) =>({...prev, 
        userNameBorrow: insert.insert_name,
      }))
    }
  }, [insert])

  const setStartDate = (e) => {
    setSearchData((prev) => ({
      ...prev,
      dateBorrow: e,
    }))
  }

  const setEndDate = (e) => {
    setSearchData((prev) => ({
      ...prev,
      dateReturn: e,
    }))
  }

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function filterForm() {
    return (
      <FormGroup row>
        <Row className="mt-3">
          <Col xxl={9} className="px-0">
            <Row>
              <Col xxl={6} className="mt-2 mb-2">
                <Row>
                  <Col>
                  <Label className="text-end ps-0">
                    วันที่ยืม
                  </Label>
                   <MyThaiDatePick showClearButton = {true} setDateObj = {setStartDate} placeholderText = "วัน/เดือน/ปี"/>
                  </Col>
                  <Col>
                  <Label className="text-end ps-0">
                    วันที่คืน
                  </Label>
                  <MyThaiDatePick minDate = {searchData.dateBorrow} showClearButton = {true} setDateObj = {setEndDate} placeholderText = "วัน/เดือน/ปี"/>
                  </Col>
                </Row>
              </Col>
              <Col xxl={3} className="mt-2 mb-2">
              <Label className="text-end ps-0">
              ประเภทครุภัณฑ์
              </Label>
              <Col className="px-0">
                <Input
                  type="select"
                  value={searchData.equipmentId}
                  onChange={(e) => {
                    setSearchData((prev) => ({
                      ...prev,
                      equipmentId: e.target.value,
                    }));
                  }}
                >
                  {allTypeOptions.map((type, index) => (
                    <option key={index} value={index === 0 ? null : type.type_name}>
                      {type.type_name}
                    </option>
                  ))}
                </Input>
              </Col>
              </Col>
              <Col xxl={3} className="mt-2 mb-2">
              <Label className="text-end ps-0">สถานะ</Label>
              <Col className="px-0">
              <Input type="select"
                defaultValue=""
                value={searchData.status}
                onChange={(e) => {
                  setSearchData((prev) => ({
                    ...prev,
                    status: e.target.value,
                  }));
                }}
              >
                <option value="">ทั้งหมด</option>
                <option value="0">จองแล้ว</option>
                <option value="1">{filterSubAdmin.length > 0 &&  (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4) ? "จ่ายแล้ว" : "รับแล้ว"}</option>
                <option value="2">คืนแล้ว</option>
                <option value="3">ไม่อนุมัติ</option>
                {/* <option value="">ยกเลิก</option> */}
              </Input>
              </Col>
              </Col>
            </Row>
          </Col>
          <Col xxl={3} className="mt-2 px-0">
          {(filterSubAdmin?.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4)) 
        ? <div  className={` 
            ${windowSize.width < 576 
              || (windowSize.width >= 576 && windowSize.width < 992 ) 
              || (windowSize.width >= 992 && windowSize.width < 1200 )
                ? "ms-0" 
                : "ms-4"
              }
          `}>
            <Label className="text-end ps-0 ">เจ้าหน้าที่</Label>
              <Col>
              <InputGroup className="w-100">
                <Input
                  readOnly
                  placeholder="...เลือกเจ้าหน้าที่"
                  type="text"
                  value= {searchData.userNameBorrow}
                />
                <ModalUser task = "select_user_filter"/>
              </InputGroup>
              </Col>
          </div>
        : ""}
          <FormGroup row className="d-flex justify-content-end px-0"></FormGroup>
          </Col>
        </Row>
        <Row xxl={12} className="mb-2">
          <Col xxl={9} className="px-0">
            <Row xxl={12}>
              <Col xxl={6}>
                <Row>
                  {/* <Col>
                  <Label className="text-end ps-0">
              Serial Number
            </Label>
            <Input
            type="text"
            placeholder="Serial Number"
            value={searchData.serialNumber}
                  onChange={(e) => {
                    setSearchData((prev) => ({
                      ...prev,
                      serialNumber: e.target.value,
                    }));
                  }}/>
                  </Col> */}
                  <Col>
                    <Label className="text-end ps-0">OPDC ID</Label>
                    <Input
                      type="text"
                      placeholder="OPDC ID"
                      value={searchData.opdcId}
                      onChange={(e) => {
                        setSearchData((prev) => ({
                          ...prev,
                          opdcId: e.target.value,
                        }));
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row xxl={12}>
          <Col></Col>
          <Col xxl={3} className="d-flex justify-content-between pt-0 px-0">
          {/* <Button style={{ minWidth : "48%" }}  color="info">
            <i className="fas fa-print me-2"></i>พิมพ์
          </Button> */}
          <ExcelExportComponent dataInput={data} equipmentName={allEquipment}/>
          <Button className="" style={{ minWidth : "48%" }} type="submit" color="success">
             <i className="me-2 fas fa-search"></i>ค้นหา
          </Button>
        </Col>
        </Row>
      </FormGroup>
    );
  }

  return (
    <div>
        <FadeIn>
          {/* <Form
            className="pt-3 px-3"
            onSubmit={(e) => {
              e.preventDefault();
              getSeachData();
            }}
          >
            <FormGroup row> */}
              <Row>
                <Col xxl={12}>
                  <Form className="pt-0 px-3"
                  onSubmit={(e) => {
                    e.preventDefault();
                    getSeachData();
                  }}
                  >
                    {filterForm()}
                  </Form>
                </Col>
              </Row>
              <Row className="mt-0">
                <Col xxl={12}>
                  <Table
                    responsive
                    striped
                    hover
                    style={{ verticalAlign: "middle", whiteSpace: "nowrap" }}
                    className="table-hover table-borderless"
                  >
                    <thead className="table-dark">
                      <tr>
                        <th className="text-center">ลำดับ</th>
                        <th>วันที่ยืม</th>
                        <th>กำหนดคืน</th>
                        <th>ประเภทอุปกรณ์</th>
                        <th>ชื่ออุปกรณ์</th>
                        <th>OPDC ID</th>
                        <th>ผู้ยืม</th>
                        <th>สถานะ</th>
                        <th>รายละเอียด</th>
                        <th>หมายเหตุ</th>
                      </tr>
                    </thead>
                    {loading ?
                      <tbody>
                        <tr>
                          <td colSpan={10}>
                            <LoadingData/>
                          </td>
                        </tr>
                      </tbody> 
                    :
                    <tbody>
                    {data.length > 0 ?
                      data.map((item, idx) => {
                        let cp = (currentPage - 1) * 10;
                        return (
                          <tr key={idx}>
                            <td className="text-center">{idx + cp + 1}</td>
                            <td>{ConvertDate(item.date_borrow)?.toThaiDateDMY()}</td>
                            <td>{ConvertDate(item.date_return)?.toThaiDateDMY()}</td>
                            <td>{allEquipment.find(y => Number(y.item_id) === Number(item.equipment_id))?.type_name}</td>
                            <td>{allEquipment.find(y => Number(y.item_id) === Number(item.equipment_id))?.detail}</td>
                            <td>{allEquipment.find(y => Number(y.item_id) === Number(item.equipment_id))?.item_format}</td>
                            <td>{item.users_name_borrow}</td>
                            <td className="text-center">
                              <span className={`${item.status === 0 ? "text-primary" : item.status === 1 ? "text-success" : item.status === 2 && "text-secondary"}`}>
                                {item.status === 0 ? "จอง" : item.status === 1 ? "จ่าย" : item.status === 2 && "คืน"}
                              </span>
                            </td>
                            <td>
                              <p className="mb-0">
                                {`ผู้จ่าย : ${item.status === 0 ? "-" : item.user_name_allot === null ? "-" : item.user_name_allot }`}
                              </p>
                              <p>
                                {`ผู้มารับ : ${item.status === 0 ? "-" : item.users_name_borrow === null ? "-" : item.users_name_borrow }`}
                              </p>
                              <p className="mb-0">
                                {`ผู้รับคืน : ${item.status === 0 ? "-" : item.users_name_returner === null ? "-" : item.users_name_returner }`}
                              </p>
                              <p className="mb-0">
                                {`ผู้คืน : ${item.status === 0 ? "-" : item.user_name_repatriate === null ? "-" : item.user_name_repatriate }`}
                              </p>
                            </td>
                            <td>{`หมายเหตุการจ่าย : ${item.remark_return ?? ""}`}</td>
                          </tr>
                        );
                      })
                    :
                      <tr>
                        <td className="text-center fs-5" colSpan={10}>
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    }
                    </tbody>}
                  </Table>
                </Col>
              </Row>
              <Row >
                <Col className="d-flex justify-content-end">
                  <Pagination
                    className="mt-3"
                    aria-label="Page navigation example"
                  >
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink onClick={() => setCurrentPage(1)}>
                        หน้าแรก
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink
                        onClick={() => setCurrentPage(currentPage - 1)}
                      >
                        ย้อนกลับ
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem active>
                      <PaginationLink>หน้า {currentPage} จาก {dataInfo.totalPage}</PaginationLink>
                    </PaginationItem>
                    <PaginationItem
                      disabled={
                        currentPage === dataInfo.totalPage ||
                        totalPages === 0
                      }
                    >
                      <PaginationLink
                        onClick={() =>
                          setCurrentPage(dataInfo.currentPage + 1)
                        }
                      >
                        ถัดไป
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem
                      disabled={
                        currentPage === totalPages || totalPages === 0
                      }
                    >
                      <PaginationLink
                        onClick={() => setCurrentPage(dataInfo.totalPage)}
                      >
                        หน้าสุดท้าย
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </Col>
                {/* <Col lg={3}>จำนวนข้อมูลที่แสดง</Col>
                <Col lg={2}>
                  <Input
                    value={pageSize}
                    type="select"
                    onChange={(e) => setPageSize(e.target.value)}
                    placeholder="...กรุณาใส่คำที่ต้องการค้นหา"
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                  </Input>
                </Col> */}
              </Row>
            {/* </FormGroup>
          </Form> */}
        </FadeIn>
    </div>
  );
};

export default Menu3;
